module.exports = __webpack_public_path__ + "static/media/full_logo_ligth.9e61d112.png";